
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { ReferenceDataType } from "@/store/referenceData/types";
import { getReferenceDataDescription } from "@/helpers/referenceData";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  computed: {
    cardFeeProfile: () => {
      const promoCode =
        store.state.promoOffer.promoCode && store.state.promoOffer.promoCode.id;

      const cardFeeProfileCode =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.cardFeeProfile;

      let cardFeeProfile = "" as any;
      if (promoCode) {
        cardFeeProfile = getReferenceDataDescription(
          cardFeeProfileCode,
          ReferenceDataType.CardFeeProfile
        );
      }
      return cardFeeProfile;
    },
    accountFeeProfile: () => {
      const accountFeeProfileCode =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.accountFeeProfile;

      const promoAccountFeeProfile = getReferenceDataDescription(
        accountFeeProfileCode,
        ReferenceDataType.AccountFeeProfile
      );

      const paymentPlan =
        store.state.application.applicationData &&
        store.state.application.applicationData.finalDetails &&
        store.state.application.applicationData.finalDetails.paymentPlan;

      const accountFeeProfile = "Monthly $0";

      return promoAccountFeeProfile || accountFeeProfile;
    },
    pricingProfile: () => {
      const promoPricingProfileCode =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.pricingProfile;

      const standardPricingProfileCode =
        store.state.standardOffer.offer &&
        store.state.standardOffer.offer.pricingProfile;

      const pricingProfileCode =
        promoPricingProfileCode || standardPricingProfileCode;

      return getReferenceDataDescription(
        pricingProfileCode,
        ReferenceDataType.PricingProfile
      );
    },
    rebateProfiles: () => {
      let promoRebateProfileCode =
        (store.state.promoOffer.promoCode &&
          store.state.promoOffer.promoCode.rebateProfile) ||
        [];

      // filter out empty values
      promoRebateProfileCode = promoRebateProfileCode.filter(v => v !== "");

      let standardPricingProfileCode =
        (store.state.standardOffer.offer &&
          store.state.standardOffer.offer.rebateProfile) ||
        [];

      // filter out empty values
      standardPricingProfileCode = standardPricingProfileCode.filter(
        v => v !== ""
      );

      const rebateProfileCode =
        promoRebateProfileCode.length > 0
          ? promoRebateProfileCode
          : standardPricingProfileCode;

      return rebateProfileCode.map(rebateProfile => {
        return getReferenceDataDescription(
          rebateProfile,
          ReferenceDataType.RebateProfile
        );
      });
    }
  }
});
